import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, MapPin, Phone, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { BrandLockup } from "./Logo";
import { NAV, CONTACT } from "../data";

export const Footer = () => (
  <footer className="bg-navy-2 pt-20 pb-8" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6">
      <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
        <div className="md:col-span-5">
          <BrandLockup eagleH="h-16" cpcH="h-14" />
          <p className="mt-6 text-white/50 text-sm max-w-sm leading-relaxed">Where tomorrow's pilots are made. An SACAA-approved Aviation Training Organisation ({CONTACT.ato}) based at Rand Airport, Johannesburg.</p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Facebook, Linkedin].map((I, i) => (
              <a key={i} href="#" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-white/70 hover:border-accent hover:text-accent-2 transition-colors" aria-label="Social"><I size={17} /></a>
            ))}
          </div>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-display text-white font-semibold mb-4">Explore</h4>
          <ul className="space-y-2.5">
            {NAV.map((n) => <li key={n.to}><Link to={n.to} className="text-white/50 text-sm hover:text-accent-2 transition-colors">{n.label}</Link></li>)}
          </ul>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-display text-white font-semibold mb-4">Get in touch</h4>
          <div className="space-y-3 text-sm">
            <p className="flex gap-3 text-white/50"><MapPin size={17} className="text-accent-2 shrink-0" />{CONTACT.address}</p>
            <a href={CONTACT.phoneHref} className="flex gap-3 text-white/50 hover:text-accent-2 transition-colors"><Phone size={17} className="text-accent-2 shrink-0" />{CONTACT.phone}</a>
            <a href={CONTACT.phone2Href} className="flex gap-3 text-white/50 hover:text-accent-2 transition-colors"><Phone size={17} className="text-accent-2 shrink-0" />{CONTACT.phone2}</a>
            <a href={`mailto:${CONTACT.email}`} className="flex gap-3 text-white/50 hover:text-accent-2 transition-colors"><Mail size={17} className="text-accent-2 shrink-0" />{CONTACT.email}</a>
          </div>
        </div>
      </div>
      <div className="pt-6 flex flex-col sm:flex-row justify-between gap-3 text-white/40 text-xs">
        <p>© {new Date().getFullYear()} Eagle 1 Flight Academy · {CONTACT.ato}. All rights reserved.</p>
        <div className="flex gap-6"><a href="#" className="hover:text-white transition-colors">Privacy Policy</a><a href="#" className="hover:text-white transition-colors">Terms</a></div>
      </div>
    </div>
  </footer>
);
